"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.99 3.535l1.278-1.269 1.406 1.376-1.631 1.62c2.39 1.054 3.683 3.893 2.53 6.48L12 22 7.428 11.743c-1.153-2.585.136-5.421 2.523-6.478L8.33 3.667l1.4-1.381 1.28 1.262V2h1.98v1.535zM12 6.79c-2.176 0-3.635 2.203-2.76 4.167l.36.806H12v1.953h-1.53L12 17.147c.94-2.108 2.018-4.201 2.83-6.36H12V8.834h2.865A3.004 3.004 0 0012 6.79z"
  })];
};

exports.default = _default;